
<template>
  <div class="my-3">
    <DxDataGrid
      :columns="columns"
      :data-source="dataStore"
      :show-borders="true"
      :search-panel="searchPanel"
      :showRowLines="true"
      :hover-state-enabled="true"
      :remote-operations="true"
      @cell-prepared="onCellPrepared"
      @cell-click="startEdit"
    >
      <DxPaging :enabled="false" />
       <DxEditing
        :allow-updating="true"
        :allow-adding="true"
        :allow-deleting="true"
        mode="popup"
      >
        <DxPopup
          :show-title="true"
          :width="700"
          :height="525"
          title="Employee Info"
        />
        <DxForm
        :form-data="formData"
        :items="items"
        :label-location="labelLocation">
       
        </DxForm>


      </DxEditing>
     
    </DxDataGrid>
  </div>
</template>
<script>
import {
  DxColumn,
  DxFormItem,
  DxPaging,
  DxEditing,
  DxLookup,
  DxPopup,
  DxForm,
} from "devextreme-vue/data-grid";
import DxDataGrid from "devextreme-vue/data-grid";
import { DxTextArea } from "devextreme-vue/text-area";
import { DxItem } from "devextreme-vue/form";
import { employees, states, products } from "@/Utils/Utils.js";
import CustomStore from "devextreme/data/custom_store";
const store = new CustomStore({
  key: "id",
  load: function (loadOptions) {
    var parameters = {};
    if (loadOptions.sort) {
      parameters.order_column = loadOptions.sort[0].selector;
      if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
    }
    parameters.filter = JSON.stringify(loadOptions.filter);
    parameters.skip = loadOptions.skip;
    parameters.take = loadOptions.take;
    parameters.page = (parameters.skip + parameters.take) / parameters.take;
    var config = {
      params: parameters,
    };
    let listurl = "/" + "product" + "/list";
    return axios
      .get(listurl, config)
      .then((response) => {
        return {
          data: response.data.results.data,
          totalCount: response.data.results.total,
        };
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  },
});
let mRoute;
let headerResponse;
function setRoute(context) {
  mRoute = context.routeDef;
}

const modelData = {};

export default {
  props: {
    detailDef: Array,
    moduleRoute: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
    relationData: Array,
  },
  components: {
    DxItem,
    DxDataGrid,
    DxColumn,
    DxFormItem,
    DxPaging,
    DxEditing,
    DxLookup,
    employees,
    products,
    DxPopup,
    DxForm,
    DxItem,
    DxTextArea,
  },
  data: function () {
    return {
      headersDef: [],
      dataStore: store,
      columns: [],

      labelLocation: "top",
      items: products,
    };
  },
  mounted() {
    setRoute(this);
  },
  methods: {
    getHeaders() {
      var parameters = {};
      var config = {
        params: parameters,
      };
      let listurl = "/" + "product" + "/header";
      return axios
        .get(listurl)
        .then((response) => {
          // handle success

          this.headersDef = response.data.results;
          var columnDefs1 = [];
          let result = this.headersDef;
          let reformattedArray = result.map((obj) => {
            let rObj = {};
            rObj["dataField"] = obj.name;
            rObj["caption"] = obj.label;
            return rObj;
          });
          columnDefs1 = columnDefs1.concat(reformattedArray);
          this.columns = columnDefs1;
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
    setColumnDefs() {
      var columnDefs1 = [];
      let result = this.headersDef;

      let reformattedArray = result.map((obj) => {
        let rObj = {};
        rObj["dataField"] = obj.name;
        rObj["caption"] = obj.label;
        return rObj;
      });
      columnDefs1 = columnDefs1.concat(reformattedArray);
      return columnDefs1;
    },

    getCreateDef() {
      var parameters = {};
      var config = {
        params: parameters,
      };
      let listurl = "/" + "product" + "/createdef";
      axios
        .get(listurl, config)
        .then((response) => {
          // handle success
          console.log("response");
          console.log(response.data.results);
          this.createDef = response.data.results;
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
  },
  created: function () {
    // showAlert("hello saurabh test");
    this.getHeaders();
    this.getCreateDef();
    this.setColumnDefs();
  },
};
</script>
<style>
#data-grid-demo {
  min-height: 700px;
}
</style>